export default "__VITE_ASSET__Bnuwdeuk__"